import React, {useEffect, useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {addSchoolAdminRequest, addUserRequest, getRegionListRequest, getSchoolTypeListRequest} from "../api";
import { clearAllCookies } from '../../../../util/handleObject';

const {Title} = Typography;
const {Option} = Select;

const { TextArea } = Input;
const AddAccountForm = (props) => {
    const [provinceList, setProvinceList] = useState([]);
    const [municipalityList, setMunicipalityList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    const [form] = Form.useForm();
    const [accountStatus, setAccountStatus] = useState(true);
    const [beizhu, setBeizhu] = useState("");
    const [schoolTypeList, setSchoolTypeList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getRegionList("1","")
        getSchoolTypeList()
    }, [props.openStatus]); // 空数组意味着这个 effect 只会在组件挂载时执行一次

    function getRegionList(regionCode, parentCode) {
        getRegionListRequest(regionCode, parentCode, (data) => {
            var newRegionList = [{
                quyu_name: "未选择",
                quyu_code: ""
            }];
            if (data.ret == 1) {
                data.data.forEach(element => {
                    newRegionList.push(element)
                });
            } else if (data.ret == 99) {
                messageApi.open({
                    type: 'warning',
                    content: data.msg
                });
                setTimeout((e) => {
                    sessionStorage.clear()
                    clearAllCookies()
                    window.location.reload()
                }, 1000)
            }
            if (regionCode == 1) {
                setProvinceList(newRegionList)
            } else if (regionCode == 2) {
                setMunicipalityList(newRegionList)
            } else if (regionCode == 3) {
                setCountyList(newRegionList)
            }

        })
    }
    function getSchoolTypeList() {
        console.log('------------')
        getSchoolTypeListRequest((data) => {
            console.log('-------------->>>>>>>>>>>.')
            var newSchoolTypeList = [{
                type_name: "未选择",
                type_code: ""
            }];
            if (data.ret == 1) {
                data.data.forEach(element => {
                    newSchoolTypeList.push(element)
                });
            }
            else {
                messageApi.open({
                    type: 'warning',
                    content: data.msg
                });
            }
            setSchoolTypeList(newSchoolTypeList)
            console.log(schoolTypeList)
        })
    }

    const onFinish = (values) => {
        var provinceName = provinceList.find(item => item.quyu_code == values.province).quyu_name;
        var dishiName =  municipalityList.find(item => item.quyu_code == values.dishi).quyu_name;
        var countyName = countyList.find(item => item.quyu_code == values.quxian).quyu_name;
        
        // 这里可以添加API调用或其他提交逻辑
        addSchoolAdminRequest(
            values.schoolName,
            values.schoolAddress,
            provinceName,
            values.province,
            dishiName,
            values.dishi,
            countyName,
            values.quxian,
            values.schoolType,
            values.userName,
            values.login,
            values.pwd,
            values.chushijifen,
            values.schoolAccountNumber,
            accountStatus?1:3,
            values.beizhu?values.beizhu:"",
            (data)=>{
                if(data.ret == 1) {
                    props.refreshList();
                    closeCommon()
                }
                else {
                    message.warning(data.msg);
                }
            }

        )
    };


    const closeCommon = () => {
        setMunicipalityList([{
            quyu_name: "未选择",
            quyu_code: ""
        }])
        setCountyList([{
            quyu_name: "未选择",
            quyu_code: ""
        }])
        form.resetFields();
        setTimeout((e)=>{
            props.closeCommonModal()
        },100)
        props.closeCommonModal()
    };

    return (
        <Modal
            maskClosable={false}
            // visible={true}
            open={props.openStatus}
            onCancel={closeCommon}
            footer={null} // 设置 footer 为 null 移除默认按钮
            width={800}
            // className="add-account-container"
        >
            {contextHolder}
            <Card className={styles["form-card"]} span={20}>
                <div className={styles["form-title"]}>添加学校信息</div>
                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                    className="account-form"
                >
                    <Form.Item
                        label="学校名称"
                        name="schoolName"
                        rules={[{required: true, message: '请输入学校名称'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入学校名称"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="学校地址"
                        name="schoolAddress"
                        rules={[{required: true, message: '请输入学校地址'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入学校地址"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="所属省份"
                        name="province"
                        rules={[{required: true, message: '请选择所属省份'},{
                            validator: (_, value) => {
                                if (value && value.includes('未选择')) {
                                    return Promise.reject(new Error(''));
                                }
                                return Promise.resolve();
                            },
                        },]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Select
                            defaultValue={"未选择"}
                            onChange={(value,label)=>{
                                getRegionList("2", value)
                                form.setFieldValue("dishi",{
                                    value:"",
                                    label:"未选择"
                                })
                                form.setFieldValue("quxian",{
                                    value:"",
                                    label:"未选择"
                                })
                            }}
                            options={
                                provinceList.map((item) => {
                                    return {
                                        value: item.quyu_code,
                                        label: item.quyu_name
                                    }
                                })
                            }
                        >
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="所属地市"
                        name="dishi"
                        rules={[{required: true, message: '请选择所属地市'},{
                            validator: (_, value) => {
                                if (value && value.includes('未选择')) {
                                    return Promise.reject(new Error(''));
                                }
                                return Promise.resolve();
                            },
                        },]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Select
                            defaultValue={"未选择"}
                            onChange={(value,label)=>{
                                console.log(value);
                                console.log("label")
                                console.log(label)

                                getRegionList("3", value)
                                form.setFieldValue("quxian",{
                                    value:"",
                                    label:"未选择"
                                })
                            }}
                            options={
                                municipalityList.map((item) => {
                                    return {
                                        value: item.quyu_code,
                                        label: item.quyu_name
                                    }
                                })
                            }
                        >
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="所属区县"
                        name="quxian"
                        rules={[{required: true, message: '请选择所属区县'},{
                            validator: (_, value) => {
                                if (value && value.includes('未选择')) {
                                    return Promise.reject(new Error(''));
                                }
                                return Promise.resolve();
                            },
                        },]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Select
                            defaultValue={"未选择"}
                            onChange={(value,label)=>{

                            }}
                            options={
                                countyList.map((item) => {
                                    return {
                                        value: item.quyu_code,
                                        label: item.quyu_name
                                    }
                                })
                            }
                        >
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="学校类型"
                        name="schoolType"
                        rules={[{required: true, message: '请选择学校类型'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Select
                            defaultValue={"未选择"}
                            onChange={(value,label)=>{

                            }}
                            options={
                                schoolTypeList.map((item) => {
                                    return {
                                        value: item.type_code,
                                        label: item.type_name
                                    }
                                })
                            }
                        >
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="用户名称"
                        name="userName"
                        rules={[{required: true, message: '请输入用户名称'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入用户名称"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="登录账号"
                        name="login"
                        rules={[{required: true, message: '请输入登录账号'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入登录账号"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="登录密码"
                        name="pwd"
                        rules={[{required: true, message: '请输入登录密码'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input.Password
                            placeholder="请输入登录密码"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="学校账户初始积分"
                        name="chushijifen"
                        rules={[{required: true, message: '请输入初始积分'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入初始积分"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="学校子账号数量"
                        name="schoolAccountNumber"
                        rules={[{required: true, message: '请输入子账号数量'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入子账号数量"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="学校账号状态"
                        name="accountStatus"
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Switch
                            onChange={(checked) => {
                                setAccountStatus(checked)
                            }}
                            checked={accountStatus}
                            // checkedChildren="开"
                            // unCheckedChildren="关"
                            // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                            style={{marginLeft: 10, marginRight: 10}}
                        />
                    </Form.Item>
                    <Form.Item
                        label="备注"
                        name="beizhu"
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <TextArea
                            placeholder='输入备注信息'
                            value={beizhu}
                            onChange={(value) => {
                                setBeizhu(value)
                            }}
                        />
                    </Form.Item>
                    <Form.Item className={styles["form-actions"]}>

                        <Button

                            size="large"
                            // onClick={() => form.resetFields()}
                            onClick={(e)=>{
                                // props.cancel()
                                form.resetFields()
                                closeCommon()
                            }}
                        >
                            取消
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            style={{marginLeft: 16}}
                        >
                            确认
                        </Button>

                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default AddAccountForm;

